import type { ReactNode } from "react";
import { theme } from "../ui";
import { useBackgroundRefreshBlocker } from "../system/useBackgroundRefresh";

export function FullScreenWaitBackdrop(props: { children: ReactNode; zIndex?: number; opaque?: boolean }) {
  useBackgroundRefreshBlocker(true);
  const {
    token: { colorBgLayout, colorText },
  } = theme.useToken();

  return (
    <div
      className="mu-fullscreen-wait"
      style={{
        position: "fixed",
        inset: "var(--mu-fullscreen-inset, 0px)",
        background: props.opaque ? colorBgLayout : `color-mix(in srgb, ${colorBgLayout} 88%, transparent)`,
        color: colorText,
        backdropFilter: props.opaque ? undefined : "blur(2px)",
        display: "grid",
        placeItems: "center",
        zIndex: props.zIndex ?? 10000,
        padding: "var(--mq-space-xl)",
      }}
    >
      {props.children}
    </div>
  );
}
